import React, { useCallback, useMemo, useState } from 'react';
import s from './s.module.less';
import { Tabs, message, type TabsProps } from 'antd';
import { getUrlParam, insertUrlParam, isDevEnv, isLocalhost } from 'utils/common';
import HelloKlarityTable from './components/HelloKlarityTable';
import PPATable from './components/PPATable';
import AirTableTable from './components/AirTableTable';
import GroupPracticeOpsPage from './components/GroupPracticeOpsPage';
import GlobalLayerStore from 'store/GlobalLayer';
import PorivderMappingModal from 'components/PorivderMappingModals/MappingModal';
import ProviderSlugModal from 'components/PorivderMappingModals/SlugUpdateModal';
import ProviderTitleModal from 'components/PorivderMappingModals/TitleUpdateModal';
import PatientRatingModal from 'components/PorivderMappingModals/PatientRatingUpdateModal';
import { EType } from 'types/helloKlarity';
import { EProviderListMappingStatusValue, IBPMappingItem } from 'types/operation';
import { updateHelloKlarityListingStatus, getHelloKlarityProviderMappingData } from 'api/operation';
import AccessStore from 'store/Access/permission';
import { PermissionModuleKeys } from 'constants/access';
import AccessDenied from 'components/AccessDenied';
import MappingModalConfirm from 'components/PorivderMappingModals/MappingModalConfirm';
import AutoRescheduleUpdateModal from 'components/PorivderMappingModals/AutoRescheduleUpdateModal';
import SFUUpdateModal from 'components/PorivderMappingModals/SFUUpdateModal';

/**
 *
 * showProviderMappingUpdateTitleModal: false,
        showProviderMappingPatientRatingModal: false,
        showProviderMappingUpdateSlugModal: false,
 */
const HelloKlarityProviders = () => {
    const [, setGlobalLayer] = GlobalLayerStore.useStore();
    const activeType = (getUrlParam('type') as EType) || EType.PPA;
    const [type, setType] = useState(activeType || EType.PPA);
    const [currentRow, setCurrentRow] = useState<IBPMappingItem | null>(null);
    const [forceUpdateBPTable, setForceUpdateBPTable] = useState({});
    const [forceUpdateATTable, setForceUpdateATTable] = useState({});
    const [getAccessStore] = AccessStore.useStore();
    const access = getAccessStore('data');

    const handleSetCurrentRow = useCallback((row: IBPMappingItem | null) => {
        setCurrentRow(row);
    }, []);

    // 当冲突的时候，比如BP这边relist，要确认AIRTABLE那边是否已经map了，如果是的话，需要弹确认提示框
    const findProviderByEmail = useCallback((email: string, tableType: number) => {
        const params = {
            // bookLink: bookingLinkList as number[],
            current: 1,
            // ehrProviderId,
            // intakeqProviderId: '',
            // listingStatus: listingStatusList as string[],
            // mappingStatus: mappingStatusList as string[],
            name: email,
            type: tableType,
        };

        return getHelloKlarityProviderMappingData(params);
    }, []);

    const handleReloadTableData = useCallback(() => {
        if (activeType === EType.PPA) {
            console.info('re ppa');
            setForceUpdateBPTable({});
        }

        if (activeType === EType.HELLOW_KLARITY) {
            console.info('re hk');
            setForceUpdateBPTable({});
        }
        if (activeType === EType.PPV) {
            console.info('re ppv');
            setForceUpdateATTable({});
        }
    }, [activeType]);

    const handleReloadAnotherTableData = useCallback(() => {
        if (activeType === EType.HELLOW_KLARITY) {
            console.info('another hk');
            setForceUpdateATTable({});
        }
        if (activeType === EType.PPV) {
            console.info('another at');
            setForceUpdateBPTable({});
        }
    }, [activeType]);

    // mapping modal
    const hideMappingModal = useCallback(() => {
        setGlobalLayer('showProviderMappingModal', false);
    }, []);

    const showMappingModal = useCallback(() => {
        setGlobalLayer('showProviderMappingModal', true);
    }, []);

    // mapping Confirm modal
    const hideMappingConfirmModal = useCallback(() => {
        setGlobalLayer('showProviderMappingConfirmModal', false);
    }, []);

    const showMappingConfirmModal = useCallback(() => {
        setGlobalLayer('showProviderMappingConfirmModal', true);
    }, []);

    const handleMappingModalOk = useCallback(() => {
        handleSetCurrentRow(null);
        handleReloadTableData();
        handleReloadAnotherTableData();
        hideMappingModal();
    }, [handleReloadAnotherTableData, handleReloadTableData, handleSetCurrentRow]);

    // slug modal
    const hideSlugModal = useCallback(() => {
        setGlobalLayer('showProviderMappingUpdateSlugModal', false);
    }, []);

    const showSlugModal = useCallback(() => {
        setGlobalLayer('showProviderMappingUpdateSlugModal', true);
    }, []);

    const handleSlugModalOk = useCallback(() => {
        handleSetCurrentRow(null);
        handleReloadTableData();
        hideSlugModal();
    }, [handleReloadTableData, handleSetCurrentRow]);

    // title modal
    const hideTitleModal = useCallback(() => {
        setGlobalLayer('showProviderMappingUpdateTitleModal', false);
    }, []);

    const showTitleModal = useCallback(() => {
        setGlobalLayer('showProviderMappingUpdateTitleModal', true);
    }, []);

    const handleTitleModalOk = useCallback(() => {
        handleSetCurrentRow(null);
        handleReloadTableData();
        hideTitleModal();
    }, [handleReloadTableData, handleSetCurrentRow]);

    // patientRating modal
    const hidePatientRatingModal = useCallback(() => {
        setGlobalLayer('showProviderMappingPatientRatingModal', false);
    }, []);

    const showPatientRatingModal = useCallback(() => {
        setGlobalLayer('showProviderMappingPatientRatingModal', true);
    }, []);

    // auto-schedule modal
    const hideAutoScheduleModal = useCallback(() => {
        setGlobalLayer('showAutoScheduleModal', false);
    }, []);

    const showAutoScheduleModal = useCallback(() => {
        setGlobalLayer('showAutoScheduleModal', true);
    }, []);

    const showSFUModal = useCallback(() => {
        setGlobalLayer('showSFUModal', true);
    }, []);

    const hideSFUModal = useCallback(() => {
        setGlobalLayer('showSFUModal', false);
    }, []);

    const handlePatientRatingModalOk = useCallback(() => {
        handleSetCurrentRow(null);
        handleReloadTableData();
        hidePatientRatingModal();
    }, [handleReloadTableData, handleSetCurrentRow]);

    const handleAutoScheduleModalOk = useCallback(() => {
        handleSetCurrentRow(null);
        handleReloadTableData();
        hideAutoScheduleModal();
    }, [handleReloadTableData, handleSetCurrentRow]);

    const handleSFUModalOk = useCallback(() => {
        handleSetCurrentRow(null);
        handleReloadTableData();
        hideSFUModal();
    }, [handleReloadTableData, handleSetCurrentRow]);

    const handleListingStatusChange = useCallback(
        async (id: number, status: EProviderListMappingStatusValue) => {
            if (id) {
                try {
                    const res = await updateHelloKlarityListingStatus({
                        id,
                        listingStatus: status,
                    });

                    if (res && !res.error) {
                        handleReloadTableData();
                        hideMappingConfirmModal();
                        handleReloadAnotherTableData();
                    } else {
                        message.error(res.error);
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        },
        [handleReloadTableData],
    );

    const commomProps = useMemo(() => {
        return {
            showMappingModal,
            showSlugModal,
            showTitleModal,
            showMappingConfirmModal,
            hideMappingConfirmModal,
            showPatientRatingModal,
            handleSetCurrentRow,
            handleListingStatusChange,
            findProviderByEmail,
            showAutoScheduleModal,
            showSFUModal,
        };
    }, [
        findProviderByEmail,
        handleListingStatusChange,
        handleSetCurrentRow,
        hideMappingConfirmModal,
        showMappingConfirmModal,
        showMappingModal,
        showPatientRatingModal,
        showSlugModal,
        showTitleModal,
        showAutoScheduleModal,
        showSFUModal,
    ]);

    const items = useMemo<TabsProps['items']>(() => {
        const ret = [
            {
                key: EType.PPA,
                label: <p className={s.tabTitle}>PPA providers</p>,
                // TODO: 需要确认权限
                children: access?.[PermissionModuleKeys.KLARITY_PROVIDER_PPA] ? (
                    <PPATable {...commomProps} forceReload={forceUpdateBPTable} />
                ) : (
                    <AccessDenied />
                ),
                forceRender: true,
            },
            {
                key: EType.HELLOW_KLARITY,
                label: <p className={s.tabTitle}>PPV providers</p>,
                children:
                    access?.[PermissionModuleKeys.KLARITY_PROVIDER_KIWI] || true ? (
                        <HelloKlarityTable {...commomProps} forceReload={forceUpdateBPTable} />
                    ) : (
                        <AccessDenied />
                    ),
                forceRender: true,
            },
            {
                key: EType.PPV,
                label: <p className={s.tabTitle}>Airtable providers</p>,
                children: access?.[PermissionModuleKeys.KLARITY_PROVIDER_AIRTABLE] ? (
                    <AirTableTable {...commomProps} forceReload={forceUpdateATTable} />
                ) : (
                    <AccessDenied />
                ),
                forceRender: true,
            },
            {
                key: EType.GROUP_PRACTICE,
                label: <p className={s.tabTitle}>Group practice</p>,
                children: <GroupPracticeOpsPage {...commomProps} forceReload={forceUpdateBPTable} />,
                forceRender: true,
            },
        ];
        return ret;
    }, [access, commomProps, forceUpdateATTable, forceUpdateBPTable]);

    return (
        <div className={s.wrap}>
            <MappingModalConfirm
                type={type}
                onOk={() => {
                    if (currentRow) {
                        handleListingStatusChange(currentRow.id, EProviderListMappingStatusValue.LISTED);
                    }
                }}
                onCancel={hideMappingConfirmModal}
            />
            <PorivderMappingModal
                row={currentRow}
                type={type}
                onOk={handleMappingModalOk}
                onCancel={hideMappingModal}
            />
            <ProviderSlugModal row={currentRow} type={type} onOk={handleSlugModalOk} onCancel={hideSlugModal} />
            <ProviderTitleModal row={currentRow} type={type} onOk={handleTitleModalOk} onCancel={hideTitleModal} />
            <PatientRatingModal
                row={currentRow}
                type={type}
                onOk={handlePatientRatingModalOk}
                onCancel={hidePatientRatingModal}
            />
            <AutoRescheduleUpdateModal
                row={currentRow}
                type={type}
                onOk={handleAutoScheduleModalOk}
                onCancel={hideAutoScheduleModal}
            />
            <SFUUpdateModal row={currentRow} type={type} onOk={handleSFUModalOk} onCancel={hideSFUModal} />
            <div className={s.title}>Hello Klarity.com providers</div>
            <Tabs
                activeKey={type}
                items={items}
                onChange={(key) => {
                    setType(key as EType);
                    insertUrlParam('type', key);
                }}
            />
        </div>
    );
};

export default HelloKlarityProviders;
